export const styleName = {
    Master: 'Master',
    SmirnoffKenya: 'Smirnoff Kenya',
    Tanqueray: 'Tanqueray',
}
export const pageContentTypes = ["contentPage", "homePage"]
export const BACKENDCONFIG = {
    staging: {
        apiKey: 'PPmnsrjGPjfYeVqHApgEuKZODJqyyQrwVkvRWEklMOVoHxDemTvnVaxbsMzMFYopVM',
    },
    production: {
        apiKey: 'htBrfkaYxvSnXlNUFDBuClglRPTmMXGJWIUSGACKtiBWgbcpJYVoHDCwhMWuTjtYEd',
    },
}
export const PRCODE = "__PR48950"